var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { API_URLS } from '../../constants/apiConstants';
import { API_SERVER_URL } from '../../utils/common/apiConfig';
import httpGet from '../../utils/http/httpGet';
var defaultParameter = {
    onePointYn: 'Y',
};
/**
 * 이용권 구매 상태를 요청합니다.
 *
 * @param requestParameter: 요청 파라미터
 * @param requestConfig: axios 요청 설정
 */
var fetchMyValidTicketList = function (requestParameter, requestConfig) {
    var filledRequestConfig = __assign(__assign({}, requestConfig), { params: __assign(__assign({}, defaultParameter), requestParameter) });
    return httpGet("".concat(API_SERVER_URL).concat(API_URLS.TVING_VALID_TICKET_LIST), filledRequestConfig).then(function (response) {
        return response.body;
    });
};
export default fetchMyValidTicketList;
